import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 3L5.73333 11.4H6H20.6667L2 3ZM2 21L5.73333 12.6H6H20.6667L2 21Z",
		fill: "currentColor"
	})
});
export default SvgSendFilled;
